
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.494 14.012l-2.603-.65-.087.216-.217.304-.044.043H7.5l-.043-.043-.217-.304-.087-.217-2.604.651h-.043v-.434s-.044-.217.304-.477c.303-.217 1.735-1.259 1.952-1.389-.043-.217-.13-1.345-.13-2.3V7.633L.167 9.716H.123L.08 9.673v-.434s0-.434.65-.781c.608-.347 2.474-1.389 2.778-1.606l-.217-.434s-.044-.217-.044-.477.044-.477.044-.477c0-.044.043-.044.043-.044h.521c.043 0 .043 0 .043.044 0 0 .087.39.087.65 0 .174-.043.348-.043.434l1.128-.65.043-.044-.13-.26s-.043-.217-.043-.478.043-.477.043-.477c0-.043.044-.043.044-.043h.52c.044 0 .044 0 .044.043 0 0 .086.39.086.651v.174l.868-.608c0-.347-.074-3.008.577-3.702.174-.087.248-.16.378-.16 0 0-.034-.014 0 0 .08.032.26.087.347.174.651.65.564 3.384.564 3.731l.868.608v-.174c-.043-.26.087-.65.087-.65 0-.044.043-.044.043-.044h.521c.043 0 .043 0 .043.043 0 0 .044.217.044.478s-.044.477-.044.477l-.13.26.044.044 1.128.65c0-.086-.044-.26-.044-.433-.043-.26.087-.651.087-.651 0-.043.044-.043.044-.043h.52c.044 0 .044 0 .044.043a2.725 2.725 0 010 .955l-.217.434c.304.173 2.126 1.258 2.734 1.562.737.347.737.78.737.78v.435s0 .043-.043.043h-.044L8.411 7.633v1.78c0 .954-.13 2.082-.13 2.3.217.13 1.606 1.17 1.953 1.388.39.26.304.52.304.52v.391h-.044z"}})])
          )
        }
      }
    